var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "reporters"
  }, [_c('div', {
    staticClass: "speaker"
  }, [_c('div', {
    staticClass: "head-top"
  }, [_c('i', {
    staticClass: "iconfont icon-publictalk"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('conferenceParticipant.publicTalk')))])]), _vm.shareInfo.rtilCode ? _c('NewAttendUser', {
    ref: "shareStreamBox",
    staticClass: "is-speaker is-share",
    class: {
      notShowFootBar: !_vm.State.showFootBar,
      showChat: _vm.showRightAside
    },
    attrs: {
      "title": _vm.shareList.tid,
      "nickName": _vm.nameList[_vm.userId],
      "singChannel": _vm.shareList,
      "isShare": true,
      "rtc": _vm.rtc,
      "volume": _vm.voiceList[_vm.shareList.id],
      "degreeHost": _vm.degreeHost[_vm.shareList.id],
      "shareInfo": _vm.shareInfo,
      "userInfo": _vm.userInfo,
      "isAudioLevel": _vm.isAudioLevel,
      "muteVideo": !_vm.State.cameraStatus[_vm.shareList.id],
      "muteAudio": !_vm.State.micStatus[_vm.shareList.id],
      "showMuteIcons": false
    },
    on: {
      "callback": _vm.attendCallback
    }
  }) : _vm._e(), _c('NewAttendUser', {
    ref: "localVideo",
    staticClass: "is-speaker is-me",
    class: {
      notShowFootBar: !_vm.State.showFootBar,
      showChat: _vm.showRightAside
    },
    attrs: {
      "title": "Me",
      "organization": _vm.organizationList[_vm.userId],
      "nickName": _vm.nameList[_vm.userId],
      "isShare": false,
      "singChannel": _vm.MeInfo,
      "isAudioLevel": _vm.isAudioLevel,
      "talkInfo": _vm.talkInfo,
      "liveInfo": _vm.liveInfo[_vm.userId] || {},
      "userInfo": _vm.userInfo,
      "rtc": _vm.rtc,
      "volume": _vm.voiceList[_vm.userId],
      "controlMute": true,
      "degreeHost": _vm.degreeHost[_vm.userInfo.rtilCode],
      "muteVideo": !_vm.State.cameraStatus[_vm.userId],
      "muteAudio": !_vm.State.micStatus[_vm.userId],
      "lockName": _vm.lockName,
      "operateList": _vm.lockName ? [] : ['rename']
    },
    on: {
      "callback": _vm.attendCallback
    }
  }, [_c('div', {
    class: _vm.returnVideoClass,
    attrs: {
      "id": "local_stream"
    }
  }), _c('div', {
    staticClass: "video-placeholder",
    attrs: {
      "id": "share_stream"
    }
  }), _c('div', {
    staticClass: "speakerTitle"
  }, [_vm._v(_vm._s(_vm.$t('conferenceHost.Speaker')))])]), _c('NewAttendUser', {
    ref: "talkInfoVideo",
    staticClass: "is-speaker is-questionSpeaker",
    class: {
      'host-questionSpeaker': _vm.questionSpeakerInfo.id == _vm.managerRtil,
      notShowFootBar: !_vm.State.showFootBar,
      showChat: _vm.showRightAside
    },
    attrs: {
      "title": _vm.questionSpeakerInfo.tid,
      "nameColor": "green",
      "isAudioLevel": _vm.isAudioLevel,
      "nickName": _vm.nameList[_vm.questionSpeakerInfo.id],
      "singChannel": _vm.questionSpeakerInfo,
      "isShare": false,
      "userInfo": _vm.userInfo,
      "rtc": _vm.rtc,
      "volume": _vm.voiceList[_vm.questionSpeakerInfo.id],
      "degreeHost": _vm.degreeHost[_vm.questionSpeakerInfo.id],
      "muteVideo": !_vm.State.cameraStatus[_vm.questionSpeakerInfo.id],
      "muteAudio": !_vm.State.micStatus[_vm.questionSpeakerInfo.id],
      "talkInfo": {
        rtilCode: _vm.questionSpeakerInfo.id
      },
      "operateList": ['hangUpInterview'],
      "currentRole": "interviewer"
    },
    on: {
      "callback": _vm.attendCallback
    }
  }, [!_vm.questionSpeakerInfo.id ? _c('div', {
    staticClass: "defaultBox"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('conferenceHost.noQuestionerDesign')))]), _c('div', [_vm._v("· " + _vm._s(_vm.$t('conferenceHost.designQuestioner')))])]) : _vm._e()])], 1), _c('div', {
    staticClass: "reporter"
  }, [_c('div', {
    staticClass: "head-top"
  }, [_c('i', {
    staticClass: "iconfont icon-questionerqueue"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('conferenceHost.questionerQueue')) + " ")]), _c('i', [_vm._v("(" + _vm._s(_vm.questionList.length) + ")")])]), _vm._l(8, function (index) {
    return _c('div', {
      key: index,
      staticClass: "videos"
    }, [_c('div', {
      staticClass: "indexNum"
    }, [_vm._v(" " + _vm._s(index) + " ")]), _c('div', {
      staticClass: "videoWidth"
    }, [_c('NewAttendUser', {
      staticClass: "participantQuestion",
      class: {
        notShowFootBar: !_vm.State.showFootBar,
        showChat: _vm.showRightAside
      },
      attrs: {
        "title": _vm.questionList[index - 1] && _vm.channel[_vm.questionList[index - 1].rtilCode] ? _vm.channel[_vm.questionList[index - 1].rtilCode].tid : '',
        "singChannel": _vm.returnStream(_vm.questionList[index - 1]),
        "userInfo": _vm.userInfo,
        "nickName": _vm.questionList[index - 1] ? _vm.nameList[_vm.questionList[index - 1].rtilCode] : '',
        "controlMute": true,
        "rtc": _vm.rtc,
        "isAudioLevel": _vm.isAudioLevel,
        "degreeHost": _vm.degreeHost[_vm.questionList[index - 1] ? _vm.questionList[index - 1].rtilCode : 0],
        "volume": _vm.voiceList[_vm.questionList[index - 1] ? _vm.questionList[index - 1].rtilCode : ''],
        "operateList": _vm.operateList[_vm.questionList[index - 1] ? _vm.questionList[index - 1].rtilCode : ''],
        "muteVideo": !_vm.State.cameraStatus[_vm.questionList[index - 1] ? _vm.questionList[index - 1].rtilCode : ''],
        "muteAudio": !_vm.State.micStatus[_vm.questionList[index - 1] ? _vm.questionList[index - 1].rtilCode : '']
      },
      on: {
        "callback": _vm.attendCallback
      }
    }, [!_vm.questionList[index - 1] ? _c('div', {
      staticClass: "defaultBox"
    }, [_c('img', {
      attrs: {
        "src": _vm.logoGray
      }
    })]) : _vm._e()])], 1), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: false,
        expression: "false"
      }]
    }, [_vm.channel[_vm.userInfo.status.managerRtil] && _vm.State.privateInfo.rtilCode == _vm.userId ? _c('NewAttendUser', {
      attrs: {
        "title": _vm.channel[_vm.userInfo.status.managerRtil].tid.toUpperCase(),
        "singChannel": _vm.channel[_vm.userInfo.status.managerRtil],
        "isShare": false,
        "rtc": _vm.rtc,
        "userInfo": _vm.userInfo
      }
    }) : _vm._e()], 1)]);
  })], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };